import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  Injector,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { Observable, tap } from 'rxjs';
import { languages } from 'src/global-variables';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.less'],
})
export class LanguageComponent extends BaseComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() mode: string;
  @Output() submitChanges: EventEmitter<any> = new EventEmitter();
  languages = languages;
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.formGroup.get('Isocode')?.valueChanges.subscribe((value) => {
        if (value != null) {
          const label = this.languages.find((x) => x.Code == value)!.Label;
          this.formGroup.get('Name')?.setValue(label);
        }
      }) ?? new Observable().subscribe()
    );
  }

  override submit() {
    this.submitChanges.emit();
  }

  recordLoaded(record: any) {
    this.commonService
      .getLanguages()
      .pipe(
        tap((response) => {
          this.commonService.dropDownMetaData['languages'] = [];
          this.commonService.dropDownMetaData['languages'] = response.value.map(
            (lang) => {
              return {
                Code: lang.Id,
                Label: lang.Name,
                Additional: lang.Isocode,
              };
            }
          );
          this.commonService.dropDownMetaData['languages'].push({
            Code: 0,
            Label: 'Default',
            Additional: 'DEFAULT',
          });
        })
      )
      .subscribe();
  }

  beforeSubmit() {}

  cleanRecord(record: any) : any{
    return record;
  }

  static controls(mode: string) {
    const controlsToReturn: any = {};
    if (mode === 'edit') {
      controlsToReturn['Id'] = [null, []];
    }

    controlsToReturn['Isocode'] = [null, [Validators.required]];
    controlsToReturn['Name'] = [null, [Validators.required]];
    controlsToReturn['IsDefault'] = [null, [Validators.required]];

    return controlsToReturn;
  }
}
